import { AxiosInstance } from "axios";

import { AppConfig } from "../config/app.config";

import { CookiesHelper } from "./cookies.helper";

interface IValidationRes {
    result: boolean;
    reason: string;
};
class AuthHelper {
    private processTokenValidation = (token: string | null): IValidationRes => {
        if (!token) {
            return { result: false, reason: 'not_found' };
        };

        try {
            const tokenPayload = JSON.parse(atob(token.split('.')[1]));
            const tokenExp = tokenPayload.exp;
            const dateNow = new Date();

            if (tokenExp < dateNow.getTime() / 1000) {
                return { result: false, reason: 'expired' };
            } else {
                return { result: true, reason: 'valid' };
            };
        } catch (e) {
            return { result: false, reason: 'invalid' };
        };
    };

    isSessionTokenValid = (): IValidationRes => {
        const sessionToken = CookiesHelper.get(AppConfig.cookieTokenNames.session);
        return this.processTokenValidation(sessionToken);
    };

    isGuestTokenValid = (): IValidationRes => {
        const authToken = CookiesHelper.get(AppConfig.cookieTokenNames.guest);
        return this.processTokenValidation(authToken);
    };

    isAuthTokenValid = (): IValidationRes => {
        const authToken = CookiesHelper.get(AppConfig.cookieTokenNames.auth);
        return this.processTokenValidation(authToken);
    };

    noSessionActive = (): boolean => {
        return !this.isSessionTokenValid().result && !this.isGuestTokenValid().result && !this.isAuthTokenValid().result;
    };

    presetSessionRequest = (api: AxiosInstance): boolean => {
        const isSessionTokenValid = this.isSessionTokenValid().result;

        const token = CookiesHelper.get(AppConfig.cookieTokenNames.session);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        return isSessionTokenValid;
    };

    presetPrivateRequest = (api: AxiosInstance): boolean => {
        const isAuthTokenValid = this.isAuthTokenValid().result;
        const isGuestTokenValid = this.isGuestTokenValid().result;

        const tokenName = isAuthTokenValid ? AppConfig.cookieTokenNames.auth : AppConfig.cookieTokenNames.guest;
        const token = CookiesHelper.get(tokenName);

        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        return isAuthTokenValid || isGuestTokenValid;
    };

    presetCustomRequest = (api: AxiosInstance, token: string): void => {
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    };
};

const authHelper = new AuthHelper();
export { authHelper as AuthHelper };